import React from "react";
import useWindowSize from "../hooks/useWindowSize";
import { MlNavigationTools } from "@mapcomponents/react-maplibre";
import MlCreatePdfButton from "./CreatePdfButton/MlCreatePdfButton";
import GpsButton from "./GpsButton";


const Buttons = ({ sx }) => {
    return (
        <>
            <MlCreatePdfButton sx={sx} mapId="map_1" />
            <GpsButton sx={sx} mapId="map_1" />       
        </>
    );
};

function NavigationTools() {
    const size = useWindowSize();

    return (
        <>
            {size.width > 1200 && (
                <MlNavigationTools mapId="map_1">
                    <Buttons />
                </MlNavigationTools>
            )}
        </>
    );
}

export default NavigationTools;
